import { cxTheme } from 'components/storybook-migration/theme-provider/system-design/theme';
import { SPACING_2, SPACING_5, SPACING_6 } from 'constants/theme-constants';
import styled from 'styled-components';

export const LegendWrapper = styled.div`
  ${({ theme }) => `
    display: flex;
    max-width: 50%;
    flex-flow: row wrap;
    align-items: center;
    justify-content: center;
    max-width: 85%;
    margin: 0 auto;
    margin-top: ${cxTheme.spacing[SPACING_6]};
    gap: ${cxTheme.spacing[SPACING_5]};
  `}
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => cxTheme.spacing[SPACING_2]};
  &:hover {
    opacity: 0.8;
    cursor: pointer;
  }
`;

export const LegendColor = styled.span`
  ${({ theme }) =>
    `
        display: block;
        height: 24px;
        width: 24px;
        border-radius: ${cxTheme.borderRadius.primaryRadius};
    `}
`;

export const LegendText = styled.p`
  ${({ theme }) => `
    color: ${theme.text.onSurface.strong};
    ${theme.label.medium.normal}
    vertical-align: middle;
    line-height: 1;
  `}
`;
